import React, { useCallback, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { ResourceState, useAdminResource } from '../TenantAdmin/shared';
import { Pagination, UsageTable, validatePage, ToolDetail } from './ToolUsage';
import { Metrics } from './AnalyticsWidgets';
import Trend from './AnalyticsTrend';

const failure = error => error?.response?.status === 404 ? 'No tool usage for the selected period.' : 'Unable to load usage. Please try again.';
export default function PeopleUsage({ api, endpoint, from, to, tenants = false }) {
  const [search, setSearch] = useState(''); const [query, setQuery] = useState({ search: '', page: 0 }); const [user, setUser] = useState(null);
  const kind = tenants ? 'tenants' : 'users';
  const resource = useAdminResource(useCallback(async () => validatePage((await api.get(`${endpoint}/${kind}`, { params: {
    range: 'custom', from, to, page: query.page, pageSize: 10, ...(query.search ? { search: query.search } : {}),
  } })).data), [api, endpoint, from, to, kind, query]), failure);
  if (user !== null) return <UserDetail api={api} endpoint={endpoint} from={from} to={to} userId={user} onBack={() => setUser(null)} />;
  return <section className="analytics-used-tools" aria-label={tenants ? 'Tenant rankings' : 'User usage'}>
    <h2>{tenants ? 'Top Tenants' : 'Users'}</h2><p>Ranked by total executions in the selected period.</p>
    <Form className="analytics-filters" onSubmit={e => { e.preventDefault(); setQuery({ search: search.trim(), page: 0 }); }}>
      <Form.Group controlId={`usage-${kind}-search`}><Form.Label>Search {kind}</Form.Label><Form.Control type="search" maxLength={100} value={search} onChange={e => setSearch(e.target.value)} /></Form.Group><Button type="submit">Search {kind}</Button>
    </Form>
    <ResourceState resource={resource}>{resource.data && <>
      <UsageTable title={tenants ? 'Tenant usage' : 'User usage'} rows={resource.data.items} kind={kind} selectUser={setUser} activeUsers={tenants} />
      <Pagination data={resource.data} name={kind} onPage={page => setQuery({ ...query, page })} />
    </>}</ResourceState>
  </section>;
}
function UserDetail({ api, endpoint, from, to, userId, onBack }) {
  const [page, setPage] = useState(0); const [tool, setTool] = useState(null);
  const resource = useAdminResource(useCallback(async () => {
    const { data } = await api.get(`${endpoint}/user`, { params: { range: 'custom', from, to, userId, page, pageSize: 10 } });
    if (String(data?.userId) !== String(userId) || !data.executions || !Array.isArray(data.trend)) throw new Error('Invalid user detail');
    validatePage(data.tools); return data;
  }, [api, endpoint, from, to, userId, page]), failure);
  if (tool !== null) return <ToolDetail api={api} endpoint={endpoint} from={from} to={to} tool={tool} platform={false} onBack={() => setTool(null)} />;
  const data = resource.data;
  return <section className="analytics-used-tools" aria-label="User usage detail"><Button onClick={onBack}>Back to users</Button>
    <ResourceState resource={resource}>{data && <><h2>User usage: {data.name}</h2><Metrics counts={data.executions} />
      {data.executions.total > 0 && <Trend days={data.trend} />}
      <UsageTable title="User most-used tools" rows={data.tools.items} kind="tools" selectTool={setTool} />
      <Pagination data={data.tools} name="user tools" onPage={setPage} />
    </>}</ResourceState>
  </section>;
}
